import localizationData from './hill.en.json';
import localized from 'model/events/util';

const events = (context, onDone) =>
  [
    {
      title: 'event.loneHill.title',
      baseWeight: 25,
      isBuild: true,
      variants: [
        {
          season: 'spring',
          day: {
            description: 'event.loneHill.spring.day.description',
            effect: { resources: { health: +5 } }
          },
          night: {
            description: 'event.loneHill.spring.night.description',
            effect: { resources: { health: +3 } }
          }
        },
        {
          season: 'summer',
          day: {
            description: 'event.loneHill.summer.day.description',
            effect: { resources: { water: -5 } }
          },
          night: {
            description: 'event.loneHill.summer.night.description',
            effect: { resources: { health: +2 } }
          }
        },
        {
          season: 'autum',
          day: {
            description: 'event.loneHill.autumn.day.description',
            effect: { resources: { food: +5 } }
          },
          night: {
            description: 'event.loneHill.autumn.night.description',
            effect: { resources: { health: +3 } }
          }
        },
        {
          season: 'winter',
          day: {
            description: 'event.loneHill.winter.day.description',
            effect: { resources: { health: -5 } }
          },
          night: {
            description: 'event.loneHill.winter.night.description',
            effect: { resources: { health: -7 } }
          }
        }
      ],
      buttons: [
        {
          title: 'event.loneHill.button.continue',
          message: 'event.loneHill.button.message.continue',
          effect: { resources: { health: +2 } }
        },
        {
          title: 'event.loneHill.button.seekShelter',
          message: 'event.loneHill.button.message.seekShelter',
          effect: { traits: { resilience: +1 } }
        }
      ]
    },
    {
      title: 'event.abandonedOutpost.title',
      baseWeight: 25,
      variants: [
        {
          season: 'spring',
          day: {
            description: 'event.abandonedOutpost.spring.day.description',
            effect: { resources: { ammo: +2 } }
          },
          night: {
            description: 'event.abandonedOutpost.spring.night.description',
            effect: { resources: { health: +5 } }
          }
        },
        {
          season: 'summer',
          day: {
            description: 'event.abandonedOutpost.summer.day.description',
            effect: { resources: { water: -3 } }
          },
          night: {
            description: 'event.abandonedOutpost.summer.night.description',
            effect: { resources: { health: +3 } }
          }
        },
        {
          season: 'autumn',
          day: {
            description: 'event.abandonedOutpost.autumn.day.description',
            effect: { resources: { food: +5 } }
          },
          night: {
            description: 'event.abandonedOutpost.autumn.night.description',
            effect: { resources: { morale: +1 } }
          }
        },
        {
          season: 'winter',
          day: {
            description: 'event.abandonedOutpost.winter.day.description',
            effect: { resources: { coins: +10 } }
          },
          night: {
            description: 'event.abandonedOutpost.winter.night.description',
            effect: { resources: { health: +2 } }
          }
        }
      ],
      buttons: [
        {
          title: 'event.abandonedOutpost.button.scavenge',
          message: 'event.abandonedOutpost.button.message.scavenge',
          effect: { resources: { food: +3, ammo: +1 } }
        },
        {
          title: 'event.abandonedOutpost.button.rest',
          message: 'event.abandonedOutpost.button.message.rest',
          effect: { resources: { health: +8 } }
        }
      ]
    },
    {
      title: 'event.rogueTradersCamp.title',
      baseWeight: 20,
      variants: [
        {
          season: 'spring',
          day: {
            description: 'event.rogueTradersCamp.spring.day.description',
            effect: { resources: { coins: -5 } }
          },
          night: {
            description: 'event.rogueTradersCamp.spring.night.description',
            effect: { resources: { morale: +5 } }
          }
        },
        {
          season: 'summer',
          day: {
            description: 'event.rogueTradersCamp.summer.day.description',
            effect: { resources: { food: +3 } }
          },
          night: {
            description: 'event.rogueTradersCamp.summer.night.description',
            effect: { resources: { coins: +5, health: -2 } }
          }
        },
        {
          season: 'autumn',
          day: {
            description: 'event.rogueTradersCamp.autumn.day.description',
            effect: { resources: { food: +5, water: +5 } }
          },
          night: {
            description: 'event.rogueTradersCamp.autumn.night.description',
            effect: { resources: { coins: -10, morale: +10 } }
          }
        },
        {
          season: 'winter',
          day: {
            description: 'event.rogueTradersCamp.winter.day.description',
            effect: { resources: { ammo: +2 } }
          },
          night: {
            description: 'event.rogueTradersCamp.winter.night.description',
            effect: { resources: { health: +5, morale: +5 } }
          }
        }
      ],
      buttons: [
        {
          title: 'event.rogueTradersCamp.button.haggle',
          message: 'event.rogueTradersCamp.button.message.haggle',
          effect: {
            resources: { food: +2, ammo: +1 },
            traits: { haggling: +1 }
          }
        },
        {
          title: 'event.rogueTradersCamp.button.share',
          message: 'event.rogueTradersCamp.button.message.share',
          effect: { resources: { morale: +8 } }
        }
      ]
    },
    {
      title: 'event.echoingCavern.title',
      baseWeight: 25,
      variants: [
        {
          season: 'spring',
          day: {
            description: 'event.echoingCavern.spring.day.description',
            effect: { resources: { water: +5 } }
          },
          night: {
            description: 'event.echoingCavern.spring.night.description',
            effect: { resources: { health: +5 } }
          }
        },
        {
          season: 'summer',
          day: {
            description: 'event.echoingCavern.summer.day.description',
            effect: { resources: { water: +10 } }
          },
          night: {
            description: 'event.echoingCavern.summer.night.description',
            effect: { resources: { health: +5, morale: +5 } }
          }
        },
        {
          season: 'autumn',
          day: {
            description: 'event.echoingCavern.autumn.day.description',
            effect: { resources: { food: +5 } }
          },
          night: {
            description: 'event.echoingCavern.autumn.night.description',
            effect: { resources: { morale: +5 } }
          }
        },
        {
          season: 'winter',
          day: {
            description: 'event.echoingCavern.winter.day.description',
            effect: { resources: { health: +3 } }
          },
          night: {
            description: 'event.echoingCavern.winter.night.description',
            effect: { resources: { health: +5, morale: +3 } }
          }
        }
      ],
      buttons: [
        {
          title: 'event.echoingCavern.button.explore',
          message: 'event.echoingCavern.button.message.explore',
          effect: { resources: { water: +5 }, traits: { stealth: +1 } }
        },
        {
          title: 'event.echoingCavern.button.rest',
          message: 'event.echoingCavern.button.message.rest',
          effect: { resources: { health: +10, morale: +5 } }
        }
      ]
    },
    {
      title: 'event.desertedHomestead.title',
      baseWeight: 20,
      variants: [
        {
          season: 'spring',
          day: {
            description: 'event.desertedHomestead.spring.day.description',
            effect: { resources: { food: +3 } }
          },
          night: {
            description: 'event.desertedHomestead.spring.night.description',
            effect: { resources: { morale: +5 } }
          }
        },
        {
          season: 'summer',
          day: {
            description: 'event.desertedHomestead.summer.day.description',
            effect: { resources: { water: -5 } }
          },
          night: {
            description: 'event.desertedHomestead.summer.night.description',
            effect: { resources: { health: +5 } }
          }
        },
        {
          season: 'autumn',
          day: {
            description: 'event.desertedHomestead.autumn.day.description',
            effect: { resources: { food: +5 } }
          },
          night: {
            description: 'event.desertedHomestead.autumn.night.description',
            effect: { resources: { morale: +5 } }
          }
        },
        {
          season: 'winter',
          day: {
            description: 'event.desertedHomestead.winter.day.description',
            effect: { resources: { health: -5 } }
          },
          night: {
            description: 'event.desertedHomestead.winter.night.description',
            effect: { resources: { morale: -5 } }
          }
        }
      ],
      buttons: [
        {
          title: 'event.desertedHomestead.button.search',
          message: 'event.desertedHomestead.button.message.search',
          effect: {
            resources: { food: +2, water: +2 },
            traits: { resilience: +1 }
          }
        },
        {
          title: 'event.desertedHomestead.button.reflect',
          message: 'event.desertedHomestead.button.message.reflect',
          effect: { resources: { morale: +10 } }
        }
      ]
    },
    {
      title: 'event.crossingRidge.title',
      baseWeight: 30,
      isBuild: true,
      variants: [
        {
          season: 'spring',
          day: {
            description: 'event.crossingRidge.spring.day.description',
            effect: { resources: { health: +5 } }
          },
          night: {
            description: 'event.crossingRidge.spring.night.description',
            effect: { resources: { health: -3 } }
          }
        },
        {
          season: 'summer',
          day: {
            description: 'event.crossingRidge.summer.day.description',
            effect: { resources: { water: -10 } }
          },
          night: {
            description: 'event.crossingRidge.summer.night.description',
            effect: { resources: { morale: +5 } }
          }
        },
        {
          season: 'autumn',
          day: {
            description: 'event.crossingRidge.autumn.day.description',
            effect: { resources: { health: -5 } }
          },
          night: {
            description: 'event.crossingRidge.autumn.night.description',
            effect: { resources: { health: -7 } }
          }
        },
        {
          season: 'winter',
          day: {
            description: 'event.crossingRidge.winter.day.description',
            effect: { resources: { health: -10 } }
          },
          night: {
            description: 'event.crossingRidge.winter.night.description',
            effect: { resources: { health: -15 } }
          }
        }
      ],
      buttons: [
        {
          title: 'event.crossingRidge.button.forgeAhead',
          message: 'event.crossingRidge.button.message.forgeAhead',
          effect: { resources: { health: +5 }, traits: { resilience: +1 } }
        },
        {
          title: 'event.crossingRidge.button.seekShelter',
          message: 'event.crossingRidge.button.message.seekShelter',
          effect: { resources: { morale: +10 }, traits: { stealth: +1 } }
        }
      ]
    },
    {
      title: 'event.scroungingForSupplies.title',
      baseWeight: 20,
      variants: [
        {
          season: 'spring',
          day: {
            description: 'event.scroungingForSupplies.spring.day.description',
            effect: { resources: { food: +1 }, traits: { luck: -1 } }
          },
          night: {
            description: 'event.scroungingForSupplies.spring.night.description',
            effect: { resources: { health: -2 }, traits: { stealth: +1 } }
          }
        },
        {
          season: 'summer',
          day: {
            description: 'event.scroungingForSupplies.summer.day.description',
            effect: { resources: { food: +2 }, traits: { resilience: -1 } }
          },
          night: {
            description: 'event.scroungingForSupplies.summer.night.description',
            effect: { resources: { health: -3 }, traits: { stealth: +2 } }
          }
        },
        {
          season: 'autumn',
          day: {
            description: 'event.scroungingForSupplies.autumn.day.description',
            effect: { resources: { food: 0 }, traits: { resilience: -2 } }
          },
          night: {
            description: 'event.scroungingForSupplies.autumn.night.description',
            effect: { resources: { health: -4 }, traits: { stealth: +3 } }
          }
        },
        {
          season: 'winter',
          day: {
            description: 'event.scroungingForSupplies.winter.day.description',
            effect: { resources: { food: -1 }, traits: { resilience: -3 } }
          },
          night: {
            description: 'event.scroungingForSupplies.winter.night.description',
            effect: { resources: { health: -5 }, traits: { luck: -2 } }
          }
        }
      ],
      buttons: [
        {
          title: 'event.scroungingForSupplies.button.searchForFood',
          message: 'event.scroungingForSupplies.button.message.searchForFood',
          effect: { resources: { food: +5 } }
        },
        {
          title: 'event.scroungingForSupplies.button.conserveEnergy',
          message: 'event.scroungingForSupplies.button.message.conserveEnergy',
          effect: { resources: { health: +1 } }
        }
      ]
    },
    {
      title: 'event.ambush.title',
      baseWeight: 30,
      isCombat: true,
      variants: [
        {
          season: 'spring',
          day: {
            description: 'event.ambush.spring.day.description',
            effect: { resources: { health: -5 } }
          },
          night: {
            description: 'event.ambush.spring.night.description',
            effect: { resources: { health: -7 } }
          }
        },
        {
          season: 'summer',
          day: {
            description: 'event.ambush.summer.day.description',
            effect: { resources: { ammo: -2 } }
          },
          night: {
            description: 'event.ambush.summer.night.description',
            effect: { resources: { ammo: -3 } }
          }
        },
        {
          season: 'autumn',
          day: {
            description: 'event.ambush.autumn.day.description',
            effect: { resources: { health: -8 } }
          },
          night: {
            description: 'event.ambush.autumn.night.description',
            effect: { resources: { health: -10 } }
          }
        },
        {
          season: 'winter',
          day: {
            description: 'event.ambush.winter.day.description',
            effect: { resources: { health: -10 } }
          },
          night: {
            description: 'event.ambush.winter.night.description',
            effect: { resources: { health: -15 } }
          }
        }
      ],
      buttons: [
        {
          title: 'event.ambush.button.counter',
          combat: {
            description: 'event.ambush.button.counter.description',
            victory: 'event.ambush.button.counter.victory',
            defeat: 'event.ambush.button.counter.defeat',
            enemies: ['bandit', 'bandit', 'bandit']
          }
        },
        {
          title: 'event.ambush.button.flee',
          message: 'event.ambush.button.message.flee',
          effect: {
            traits: { stealth: +1 }
          }
        }
      ]
    },
    {
      title: 'event.gulchAmbush.title',
      baseWeight: 25,
      isCombat: true,
      variants: [
        {
          season: 'spring',
          day: {
            description: 'event.gulchAmbush.spring.day.description',
            effect: { resources: { health: -10 } }
          },
          night: {
            description: 'event.gulchAmbush.spring.night.description',
            effect: { resources: { morale: +10 } }
          }
        },
        {
          season: 'summer',
          day: {
            description: 'event.gulchAmbush.summer.day.description',
            effect: { resources: { ammo: -3 } }
          },
          night: {
            description: 'event.gulchAmbush.summer.night.description',
            effect: { resources: { health: +5 } }
          }
        },
        {
          season: 'autumn',
          day: {
            description: 'event.gulchAmbush.autumn.day.description',
            effect: { resources: { health: -8 } }
          },
          night: {
            description: 'event.gulchAmbush.autumn.night.description',
            effect: { resources: { morale: +5 } }
          }
        },
        {
          season: 'winter',
          day: {
            description: 'event.gulchAmbush.winter.day.description',
            effect: { resources: { health: -15 } }
          },
          night: {
            description: 'event.gulchAmbush.winter.night.description',
            effect: { resources: { health: +5 } }
          }
        }
      ],
      buttons: [
        {
          title: 'event.gulchAmbush.button.negotiate',
          message: 'event.gulchAmbush.button.message.negotiate',
          effect: {
            resources: { ammo: -1, health: +10 },
            traits: { charisma: +1 }
          }
        },
        {
          title: 'event.gulchAmbush.button.defend',
          message: 'event.gulchAmbush.button.message.defend',
          combat: {
            enemies: ['bandit', 'bandit', 'bandit'],
            description: 'event.gulchAmbush.button.defend.description',
            victory: 'event.gulchAmbush.button.defend.victory',
            defeat: 'event.gulchAmbush.button.defend.defeat'
          }
        }
      ]
    },
    {
      title: 'event.caravanConfrontation.title',
      baseWeight: 25,
      variants: [
        {
          season: 'spring',
          day: {
            description: 'event.caravanConfrontation.spring.day.description',
            effect: { resources: { coins: -10 } }
          },
          night: {
            description: 'event.caravanConfrontation.spring.night.description',
            effect: { resources: { morale: +10 } }
          }
        },
        {
          season: 'summer',
          day: {
            description: 'event.caravanConfrontation.summer.day.description',
            effect: { resources: { water: -5 } }
          },
          night: {
            description: 'event.caravanConfrontation.summer.night.description',
            effect: { resources: { health: +5 } }
          }
        },
        {
          season: 'autumn',
          day: {
            description: 'event.caravanConfrontation.autumn.day.description',
            effect: { resources: { ammo: -2 } }
          },
          night: {
            description: 'event.caravanConfrontation.autumn.night.description',
            effect: { resources: { morale: +15 } }
          }
        },
        {
          season: 'winter',
          day: {
            description: 'event.caravanConfrontation.winter.day.description',
            effect: { resources: { health: -10 } }
          },
          night: {
            description: 'event.caravanConfrontation.winter.night.description',
            effect: { resources: { health: +10 } }
          }
        }
      ],
      buttons: [
        {
          title: 'event.caravanConfrontation.button.barter',
          message: 'event.caravanConfrontation.button.message.barter',
          effect: {
            resources: { coins: -5, health: +5 },
            traits: { haggling: +1 }
          }
        },
        {
          title: 'event.caravanConfrontation.button.diplomacy',
          message: 'event.caravanConfrontation.button.message.diplomacy',
          effect: {
            traits: { charisma: +1 },
            resources: { morale: +20 }
          }
        }
      ]
    },
    {
      title: 'event.predatorsShadow.title',
      baseWeight: 25,
      isCombat: true,
      variants: [
        {
          season: 'spring',
          day: {
            description: 'event.predatorsShadow.spring.day.description',
            effect: { resources: { health: -5 } },
            enemies: ['cougar']
          },
          night: {
            description: 'event.predatorsShadow.spring.night.description',
            effect: { resources: { morale: +5 } },
            enemies: ['wolf', 'wolf']
          }
        },
        {
          season: 'summer',
          day: {
            description: 'event.predatorsShadow.summer.day.description',
            effect: { resources: { ammo: -2 } },
            enemies: ['bear']
          },
          night: {
            description: 'event.predatorsShadow.summer.night.description',
            effect: { resources: { health: +5 } },
            enemies: ['cougar']
          }
        },
        {
          season: 'autumn',
          day: {
            description: 'event.predatorsShadow.autumn.day.description',
            effect: { resources: { health: -8 } },
            enemies: ['cougar']
          },
          night: {
            description: 'event.predatorsShadow.autumn.night.description',
            effect: { resources: { morale: +10 } },
            enemies: ['wolf', 'wolf', 'wolf']
          }
        },
        {
          season: 'winter',
          day: {
            description: 'event.predatorsShadow.winter.day.description',
            effect: { resources: { health: -15 } },
            enemies: ['bear']
          },
          night: {
            description: 'event.predatorsShadow.winter.night.description',
            effect: { resources: { health: +5 } },
            enemies: ['bear']
          }
        }
      ],
      buttons: [
        {
          title: 'event.predatorsShadow.button.fight',
          message: 'event.predatorsShadow.button.message.fight',
          combat: {
            description: 'event.predatorsShadow.button.fight.description',
            victory: 'event.predatorsShadow.button.fight.victory',
            defeat: 'event.predatorsShadow.button.fight.defeat'
          }
        },
        {
          title: 'event.predatorsShadow.button.flee',
          message: 'event.predatorsShadow.button.message.flee',
          effect: {
            traits: { stealth: +1 },
            resources: { health: +5 }
          }
        }
      ]
    },
    {
      title: 'event.beastsBellow.title',
      baseWeight: 25,
      isCombat: true,
      variants: [
        {
          season: 'spring',
          day: {
            description: 'event.beastsBellow.spring.day.description',
            effect: { resources: { health: -10 } },
            enemies: ['bear']
          },
          night: {
            description: 'event.beastsBellow.spring.night.description',
            effect: { resources: { morale: +5 } },
            enemies: ['wolf']
          }
        },
        {
          season: 'summer',
          day: {
            description: 'event.beastsBellow.summer.day.description',
            effect: { resources: { ammo: -3 } },
            enemies: ['cougar']
          },
          night: {
            description: 'event.beastsBellow.summer.night.description',
            effect: { resources: { health: +5 } },
            enemies: ['bear']
          }
        },
        {
          season: 'autumn',
          day: {
            description: 'event.beastsBellow.autumn.day.description',
            effect: { resources: { health: -8 } },
            enemies: ['bear']
          },
          night: {
            description: 'event.beastsBellow.autumn.night.description',
            effect: { resources: { morale: +10 } },
            enemies: ['wolf', 'wolf', 'wolf']
          }
        },
        {
          season: 'winter',
          day: {
            description: 'event.beastsBellow.winter.day.description',
            effect: { resources: { health: -15 } },
            enemies: ['cougar']
          },
          night: {
            description: 'event.beastsBellow.winter.night.description',
            effect: { resources: { health: +5 } },
            enemies: ['bear']
          }
        }
      ],
      buttons: [
        {
          title: 'event.beastsBellow.button.confront',
          combat: {
            description: 'event.beastsBellow.button.confront.description',
            victory: 'event.beastsBellow.button.confront.victory',
            defeat: 'event.beastsBellow.button.confront.defeat'
          }
        },
        {
          title: 'event.beastsBellow.button.evade',
          message: 'event.beastsBellow.button.message.evade',
          effect: {
            traits: { stealth: +1 },
            resources: { food: -10, water: -10 }
          }
        }
      ]
    },
    {
      title: 'event.highwaymenToll.title',
      baseWeight: 25,
      isCombat: true,
      variants: [
        {
          season: 'spring',
          day: {
            description: 'event.highwaymenToll.spring.day.description',
            effect: { resources: { coins: -15 } }
          },
          night: {
            description: 'event.highwaymenToll.spring.night.description',
            effect: { resources: { health: -5 } }
          }
        },
        {
          season: 'summer',
          day: {
            description: 'event.highwaymenToll.summer.day.description',
            effect: { resources: { ammo: -2 } }
          },
          night: {
            description: 'event.highwaymenToll.summer.night.description',
            effect: { resources: { health: +10 } }
          }
        },
        {
          season: 'autumn',
          day: {
            description: 'event.highwaymenToll.autumn.day.description',
            effect: { resources: { health: -8 } }
          },
          night: {
            description: 'event.highwaymenToll.autumn.night.description',
            effect: { resources: { morale: +5 } }
          }
        },
        {
          season: 'winter',
          day: {
            description: 'event.highwaymenToll.winter.day.description',
            effect: { resources: { health: -15 } }
          },
          night: {
            description: 'event.highwaymenToll.winter.night.description',
            effect: { resources: { health: +5 } }
          }
        }
      ],
      buttons: [
        {
          title: 'event.highwaymenToll.button.negotiate',
          message: 'event.highwaymenToll.button.message.negotiate',
          effect: {
            resources: { coins: -30 },
            traits: { charisma: +1 }
          }
        },
        {
          title: 'event.highwaymenToll.button.fight',
          combat: {
            description: 'event.highwaymenToll.button.fight.description',
            victory: 'event.highwaymenToll.button.fight.victory',
            defeat: 'event.highwaymenToll.button.fight.defeat',
            enemies: ['bandit', 'bandit', 'bandit']
          }
        }
      ]
    },
    {
      title: 'event.misplacedGear.title',
      baseWeight: 15,
      variants: [
        {
          season: 'spring',
          day: {
            description: 'event.misplacedGear.spring.day.description',
            effect: { resources: { food: -5, water: -5 } }
          },
          night: {
            description: 'event.misplacedGear.spring.night.description',
            effect: { resources: { morale: -5 } }
          }
        },
        {
          season: 'summer',
          day: {
            description: 'event.misplacedGear.summer.day.description',
            effect: { resources: { ammo: -2 } }
          },
          night: {
            description: 'event.misplacedGear.summer.night.description',
            effect: { resources: { health: -5 } }
          }
        },
        {
          season: 'autumn',
          day: {
            description: 'event.misplacedGear.autumn.day.description',
            effect: { resources: { coins: -10 } }
          },
          night: {
            description: 'event.misplacedGear.autumn.night.description',
            effect: { resources: { morale: -10 } }
          }
        },
        {
          season: 'winter',
          day: {
            description: 'event.misplacedGear.winter.day.description',
            effect: { resources: { food: -5 } }
          },
          night: {
            description: 'event.misplacedGear.winter.night.description',
            effect: { resources: { health: -10 } }
          }
        }
      ],
      buttons: [
        {
          title: 'event.misplacedGear.button.retrieve',
          message: 'event.misplacedGear.button.message.retrieve',
          effect: {
            resources: { food: +3, water: +3 },
            traits: { resilience: +1 }
          }
        },
        {
          title: 'event.misplacedGear.button.moveOn',
          message: 'event.misplacedGear.button.message.moveOn',
          effect: {
            traits: { stealth: +1 },
            resources: { morale: +5 }
          }
        }
      ]
    },
    {
      title: 'event.tenseEncounter.title',
      baseWeight: 10,
      isCombat: true,
      variants: [
        {
          season: 'spring',
          day: {
            description: 'event.tenseEncounter.spring.day.description',
            effect: { resources: { health: -5 } }
          },
          night: {
            description: 'event.tenseEncounter.spring.night.description',
            effect: { resources: { morale: -5 } }
          }
        },
        {
          season: 'summer',
          day: {
            description: 'event.tenseEncounter.summer.day.description',
            effect: { resources: { ammo: -2 } }
          },
          night: {
            description: 'event.tenseEncounter.summer.night.description',
            effect: { resources: { health: +5 } }
          }
        },
        {
          season: 'autumn',
          day: {
            description: 'event.tenseEncounter.autumn.day.description',
            effect: { resources: { coins: -10 } }
          },
          night: {
            description: 'event.tenseEncounter.autumn.night.description',
            effect: { resources: { morale: +5 } }
          }
        },
        {
          season: 'winter',
          day: {
            description: 'event.tenseEncounter.winter.day.description',
            effect: { resources: { health: -10 } }
          },
          night: {
            description: 'event.tenseEncounter.winter.night.description',
            effect: { resources: { health: +5 } }
          }
        }
      ],
      buttons: [
        {
          title: 'event.tenseEncounter.button.confront',
          combat: {
            description: 'event.tenseEncounter.button.confront.description',
            victory: 'event.tenseEncounter.button.confront.victory',
            defeat: 'event.tenseEncounter.button.confront.defeat',
            enemies: ['raider', 'raider', 'raider', 'raider']
          }
        },
        {
          title: 'event.tenseEncounter.button.evade',
          message: 'event.tenseEncounter.button.message.evade',
          effect: {
            traits: { stealth: +1 },
            resources: { health: +5 }
          }
        }
      ]
    },
    {
      title: 'event.stampedeScare.title',
      baseWeight: 12,
      variants: [
        {
          season: 'spring',
          day: {
            description: 'event.stampedeScare.spring.day.description',
            effect: { resources: { health: -10 } }
          },
          night: {
            description: 'event.stampedeScare.spring.night.description',
            effect: { resources: { morale: -5 } }
          }
        },
        {
          season: 'summer',
          day: {
            description: 'event.stampedeScare.summer.day.description',
            effect: { resources: { ammo: -2 } }
          },
          night: {
            description: 'event.stampedeScare.summer.night.description',
            effect: { resources: { health: +5 } }
          }
        },
        {
          season: 'autumn',
          day: {
            description: 'event.stampedeScare.autumn.day.description',
            effect: { resources: { coins: -10 } }
          },
          night: {
            description: 'event.stampedeScare.autumn.night.description',
            effect: { resources: { morale: +5 } }
          }
        },
        {
          season: 'winter',
          day: {
            description: 'event.stampedeScare.winter.day.description',
            effect: { resources: { health: -15 } }
          },
          night: {
            description: 'event.stampedeScare.winter.night.description',
            effect: { resources: { health: +5 } }
          }
        }
      ],
      buttons: [
        {
          title: 'event.stampedeScare.button.holdFirm',
          combat: {
            description: 'event.stampedeScare.button.holdFirm.description',
            victory: 'event.stampedeScare.button.holdFirm.victory',
            defeat: 'event.stampedeScare.button.holdFirm.defeat',
            enemies: ['buffalo', 'buffalo', 'buffalo']
          }
        },
        {
          title: 'event.stampedeScare.button.takeCover',
          message: 'event.stampedeScare.button.message.takeCover',
          effect: {
            traits: { stealth: +1 },
            resources: { food: -10, water: -20, coins: -10 }
          }
        }
      ]
    }
  ].map(event => localized(event, localizationData));

export default events;
